import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from 'components/common';
import { confirmEmail } from 'redux/settingsSlice';
import { useDispatch } from 'react-redux';
import authAxios from 'helpers/authAxios';
import { extractApiError } from 'helpers/apiError';

const ForgetPasswordForm = () => {
  // State
  const [email, setEmail] = useState('');
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      try{
        await authAxios.post('/passwords', {email})
        dispatch(confirmEmail(email))

        // Worded to match what the API now answers: it says the same thing
        // whether or not that address has an account, because saying otherwise
        // told anyone who asked who works here.
        toast.success(`If ${email} is in our system, a reset link is on its way`);
        navigate('/authentication/confirm-mail')
      }
      catch(err)
      {
        toast.error(extractApiError(err));
      }
    }
  };

  return (
    <form className="tw-mt-4" onSubmit={handleSubmit}>
      <div className="tw-mb-3">
        <input
          className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-solid tw-border-slate-300 tw-rounded-md tw-bg-white tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          placeholder={'Email address'}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </div>

      <div className="tw-mb-3">
        <Button fullWidth type="submit" disabled={!email}>
          Send reset link
        </Button>
      </div>

      <Link className="tw-text-sm tw-text-slate-500" to="#!">
        I can't recover my account using this page
        <span className="tw-inline-block tw-ml-1"> &rarr;</span>
      </Link>
    </form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
